import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyBzsyHsI6uk1kdoMtvBjL3BawIqYZcdW5Y",
  authDomain: "lists-6775f.firebaseapp.com",
  projectId: "lists-6775f",
  storageBucket: "lists-6775f.appspot.com",
  messagingSenderId: "826462314079",
  appId: "1:826462314079:web:b218464570799914e485ea",
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const auth = getAuth(app);
